class ProductGallery extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;
    this.productUrl = this.dataset.productUrl;
    this.section = document.getElementById(`shopify-section-${this.sectionId}`);
    if ( this.section ) {
      this.variantPicker = this.section.querySelector('variant-picker');
    }
  }
  disconnectedCallback() {
    if (this.variantPicker) {
      this.variantPicker.removeEventListener('variant:change', this.handleVariantChange.bind(this));
    }
  }
  connectedCallback() {
    this.setVariantPickerEvent();
  }
  setVariantPickerEvent(){
    if (this.variantPicker) {
      this.variantPicker.addEventListener('variant:change', (event) => {
        this.handleVariantChange(event)
      });
    }
  }

  handleVariantChange( event ){
    const variant = event?.detail?.variant;
    const fetchUrl = new URL(this.productUrl, window.location.origin);
    fetchUrl.searchParams.set("section_id", this.sectionId);
    fetchUrl.searchParams.set("variant", variant.id);
    fetch(fetchUrl.href)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.text();
      })
      .then((data) => {
        const template = document.createElement("template");
        template.innerHTML = data.trim();
        const newGallery = template.content.querySelector(".product-gallery-slider");
        const oldGallery = this.section.querySelector(".product-gallery-slider");
        if (newGallery && oldGallery) {
          // Replace the old gallery with the new one
          oldGallery.replaceWith(newGallery);
        }
      })
      .catch(function (err) {
        console.error(err);
      });
  }
}

if ( !customElements.get('product-gallery')) {
  customElements.define('product-gallery', ProductGallery);
}